import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React, { useMemo } from 'react'
import { Badge } from 'reactstrap'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const defaultStatuses = [
  'draft', 'sent', 'scheduled', 'finished', 'cancel'
  //'cancel', 'finished'
]

const StatusesFilter = (props) => {
  const { translate } = useTranslation()
  const {
    statusFilters,
    setStatusFilters,
    useInner = false,
    statuses = defaultStatuses,
    visualOnlyStatusIds = []
  } = props
  const pillColor = (itemIn) => {
    let statusClass
    const item = itemIn?.id || itemIn
    switch (item) {
      case 'draft':
        statusClass = 'gray'
        break
      case 'sent':
        statusClass = `error`
        break
      case 'scheduled':
        statusClass = 'primary'
        break
      case 'paid':
        statusClass = 'success'
        break
      case 'cancel':
        statusClass = '#000'
        break
      // case 'pause':
      //   statusClass = 'primary'
      //   break
      case 'resume':
        statusClass = 'secondary'
        break
      case 'finished':
        statusClass = '#9BE313'
        break
      case 'inProgress':
        statusClass = 'primary'
        break;
      default:
        statusClass = 'secondary'
        break
    }
    return statusClass
  }
  const selectorData = useMemo(() => statuses.map((item) => {
    const isString = typeof item === 'string'
    const baseObj = isString ? {} : item || {}
    return {
      ...baseObj,
      ids: item?.ids,
      multi: item?.multi,
      name: isString ? translate(`plans.status.${item}`) : item?.name,
      id: isString ? item : item?.id,
      className: item?.className || '',   
        Component: (
        <Badge
          color={item?.statusColor || pillColor(item)}
          style={{
            width: 8,
            height: 8,
            minHeight: 8,
            padding: 0,
            marginRight: 8,
            border: 'none',
            lineHeight: 0,
            flexShrink: 0,
            ...(pillColor(item).includes('#') ? { backgroundColor: pillColor(item) } : {})
          }}
          pill
          className='point'
        >
          &nbsp;
        </Badge>
      )
    }
  }), 
  // eslint-disable-next-line
  [statuses, translate])


  const selectorProps = {
    setDataFilters: setStatusFilters,
    direction: 'bottom',
    dataFilters: statusFilters,
    typeFilter: 'statuses',
    data: selectorData,
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  const filterBadgeOptions = selectorData.filter((option) => !visualOnlyStatusIds.includes(option.id))
  const filterBadgeSelectedIds = (statusFilters || []).filter((status) => !visualOnlyStatusIds.includes(status))

  return (
    useInner ?
      <CheckboxSelectorInner
        style={{maxWidth: 'auto'}}
        {...selectorProps}
      /> :
      <CheckboxSelector {...selectorProps}>
        <FilterBadge
          title={translate('filters.plans.status.title')}
          options={filterBadgeOptions}
          selectedIds={filterBadgeSelectedIds}
          showOptionComponents
          onClearFilters={() => setStatusFilters([])}
        />
      </CheckboxSelector>
  )
}
export default StatusesFilter
